/**
 * ID55 — 수기주문 등록 FE 타입. (be-manual-order 계약 — order-service docs/qa-fix/order-admin/ID55.md.)
 * 전화 주문·B2B 대량주문을 운영자가 백오피스에서 직접 등록 → POST /admin/v1/orders/manual.
 */

/** 회원/비회원 구분. */
export type MemberType = 'MEMBER' | 'GUEST';

/** 배송/픽업. */
export type FulfillmentType = 'DELIVERY' | 'PICKUP';

export const FULFILLMENT_TYPES: ReadonlyArray<FulfillmentType> = ['DELIVERY', 'PICKUP'];

/** 결제수단 — 무통장(입금예정) / 즉시결제완료. 라벨은 i18n(manualOrder.paymentMethod.*) 정본. */
export type ManualPaymentMethod = 'BANK_TRANSFER' | 'PAID';

export const MANUAL_PAYMENT_METHODS: ReadonlyArray<ManualPaymentMethod> = [
  'BANK_TRANSFER',
  'PAID',
];

/** 주문 상품 라인(요청). unitPrice 미지정 시 BE 가 catalog 자동조회. */
export interface ManualOrderLine {
  productId: string;
  variantId?: string | null;
  qty: number;
  /** 운영자 입력 단가(KRW). 미지정 시 catalog 판매가 자동조회. */
  unitPrice?: number | null;
}

/**
 * 화면용 선택 상품 행 — 상품명/썸네일 등 표시 메타를 동반한다.
 * 제출 시 ManualOrderLine 으로 축약.
 */
export interface SelectedProductRow {
  productId: string;
  variantId?: string | null;
  productName: string;
  thumbnailUrl?: string | null;
  /** 카탈로그 판매가(표시·기본 단가). null 이면 미조회. */
  listPrice?: number | null;
  qty: number;
  /** 운영자 override 단가. 빈 문자열이면 미지정(자동조회). */
  unitPrice: string;
}

/** POST body — ManualOrderCreateRequest. */
export interface ManualOrderCreateRequest {
  memberType: MemberType;
  /** MEMBER 시 필수. */
  userId?: string | null;
  /** GUEST 시 필수. */
  ordererName?: string | null;
  ordererPhone?: string | null;
  ordererEmail?: string | null;
  lines: ManualOrderLine[];
  fulfillmentType: FulfillmentType;
  shippingFee: number;
  discountAmount: number;
  paymentMethod: ManualPaymentMethod;
  /** BANK_TRANSFER 선택(미지정 시 서버 기본 TTL). ISO-8601. */
  paymentDueAt?: string | null;
  recipientName?: string | null;
  recipientPhone?: string | null;
  recipientPostalCode?: string | null;
  recipientAddress1?: string | null;
  recipientAddress2?: string | null;
  /** 미지정 시 KR. */
  recipientCountryCode?: string | null;
  deliveryMessage?: string | null;
  adminMemo?: string | null;
}

/** envelope data 의 금액 표현(Money). */
export interface Money {
  amount: number;
  currencyCode: string;
}

export interface ManualOrderResponseLine {
  orderItemId: string;
  productId: string;
  variantId: string | null;
  productName: string;
  thumbnailUrl: string | null;
  qty: number;
  unitPrice: Money;
  lineAmount: Money;
}

/** 응답 — ManualOrderCreateResponse(envelope data). */
export interface ManualOrderCreateResponse {
  orderId: string;
  orderNo: string;
  orderStatus: string;
  paymentStatus: string;
  displayStatus: string;
  paymentMethod: string;
  itemAmount: Money;
  shippingFee: Money;
  discountAmount: Money;
  payableAmount: Money;
  paymentDueAt: string | null;
  fulfillmentType: FulfillmentType;
  lines: ManualOrderResponseLine[];
}

/** 최대 주문 라인 수(be-manual-order 검증: 1~500). */
export const MANUAL_ORDER_MAX_LINES = 500;
